export default {
  'YouTube and High Definition Videos': 'YouTube e Vídeo em Alta Definição',
  'Story videos (Instagram/Snaps/TikTok)': 'Vídeos para Story (Instagram/Snaps/TikTok)',
  'Facebook and Instagram Feed videos': 'Vídeos para o Feed de Facebook e Instagram',
  'Facebook and Twitter Portrait Videos': 'Vídeos de Retrato no Facebook e Twitter',
  'Twitter and Facebbok Landscape Videos': 'Vídeos de Paisagem no Twitter e Facebbok',
  'Facebook Cover Videos And Blog Banners': 'Vídeos de Capa do Facebook e Banners de Blog',
  'Fit': 'Ajustar',
  'Fill': 'Preencher',
}